import Table from "../../../components/table/table";
import { IoEyeOutline } from "react-icons/io5";
const VacationsTable = ({ t, setSelected, setOpenEdit }) => {
  const employees = [
    {
      days: "5",
      status: "يراجع",
      startDate: "20/06/2023",
      endDate: "15/06/2023",
      type: "إجازة سنوية",
      id: "1",
      employee: "أحمد هشام المدير",
    },
    {
      days: "1",
      status: "مرفوض",
      startDate: "08/06/2023",
      endDate: "08/06/2023",
      type: "إجازة اضطرارية",
      id: "2",
      employee: "علي أحمد",
    },
    {
      days: "5",
      status: "يراجع",
      startDate: "20/06/2023",
      endDate: "15/06/2023",
      type: "إجازة سنوية",
      id: "3",
      employee: "أحمد هشام المدير",
    },
    {
      days: "1",
      status: "تم الموافقة",
      startDate: "08/06/2023",
      endDate: "08/06/2023",
      type: "إجازة مرضية",
      id: "4",
      employee: "علي أحمد",
    },
    {
      days: "2",
      status: "يراجع",
      startDate: "12/06/2023",
      endDate: "10/06/2023",
      type: "إجازة سنوية",
      id: "5",
      employee: "سيد أحمد",
    },
    {
      days: "5",
      status: "يراجع",
      startDate: "20/06/2023",
      endDate: "15/06/2023",
      type: "إجازة سنوية",
      id: "6",
      employee: "أحمد هشام المدير",
    },
    {
      days: "1",
      status: "مرفوض",
      startDate: "08/06/2023",
      endDate: "08/06/2023",
      type: "إجازة اضطرارية",
      id: "7",
      employee: "علي أحمد",
    },
    {
      days: "2",
      status: "تم الموافقة",
      startDate: "12/06/2023",
      endDate: "10/06/2023",
      type: "إجازة مرضية",
      id: "8",
      employee: "سيد أحمد",
    },
  ];

  const tableHead = [
    {
      header: "id",
      accessorKey: "id",
    },
    {
      header: t("employee"),
      accessorKey: "employee",
    },
    {
      header: t("vacationType"),
      accessorKey: "vacationType",
    },
    {
      header: t("startDate"),
      accessorKey: "startDate",
    },
    {
      header: t("endDate"),
      accessorKey: "endDate",
    },
    {
      header: t("numberOfDays"),
      accessorKey: "days",
    },
    {
      header: t("status"),
      accessorKey: "status",
    },

    {
      header: t("actions"),
      accessorKey: "actions",
    },
  ];
  const tableData = employees.map((m, i) => {
    const statusColor =
      m.status === "تم الموافقة"
        ? "#E6F4EF"
        : m.status === "مرفوض"
        ? "#FFE6E6"
        : "#FFEBCA";
    const statusTextColor =
      m.status === "تم الموافقة"
        ? "#11A849"
        : m.status === "مرفوض"
        ? "#C42E27"
        : "#F59E0B";
    const status = (
      <span
        style={{ backgroundColor: statusColor, color: statusTextColor }}
        className="block w-full px-2 py-1 rounded-lg"
      >
        {m.status}
      </span>
    );
    const actions = (
      <div
        onClick={() => {
          setOpenEdit(true);
          setSelected(m);
        }}
        className="relative mx-auto w-fit"
      >
        <IoEyeOutline size={24} className="text-primary" />
      </div>
    );
    return {
      id: m.id,
      employee: m.employee,
      vacationType: m.type,
      startDate: m.startDate,
      endDate: m.endDate,
      days: m.days,
      status,
      actions,
    };
  });
  return <Table TableData={tableData} TableHead={tableHead} />;
};

export default VacationsTable;
